import { render } from "./MassageSp.vue?vue&type=template&id=0b329d3c&scoped=true"
import script from "./MassageSp.vue?vue&type=script&lang=js"
export * from "./MassageSp.vue?vue&type=script&lang=js"

import "./MassageSp.vue?vue&type=style&index=0&id=0b329d3c&lang=css"
import "./MassageSp.vue?vue&type=style&index=1&id=0b329d3c&scoped=true&lang=css"
import "./MassageSp.vue?vue&type=style&index=2&id=0b329d3c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b329d3c"]])

export default __exports__